import { map, pluck } from 'rxjs/operators'
import { DocsType } from '../../../actions/docs/docsTypes'
import { ofType, ActionsObservable } from 'redux-observable'
import { PlayInObject } from '../../../../lib/playIn/types'
import { ReduxAction } from '../../../reducers/reducerType'

import { setSyncPlayInState } from '../../../actions/docs/syncPlayIn/syncPlayInActions'

const setPlayInInitialState$ = (actions$: ActionsObservable<ReduxAction>) => actions$.pipe(
  ofType(DocsType.SET_PLAY_IN_DOCUMENT),
  pluck('payload'),
  pluck('data'),
  map((docValue: PlayInObject) => setSyncPlayInState(docValue, true))
)

export default setPlayInInitialState$
